module.exports = __webpack_public_path__ + "static/media/GulinareSeries4.f0b80c10.jpg";